import { message } from "antd";
import { postData } from "apiServices/common";
import { dateUtils } from "./calendarUtils";

export const createDragDropHandlers = (
  setDraggedIndex,
  setDropActiveIndex,
  setDroppingIndex,
) => ({
  handleDragStart: (e, params) => {
    const { line_index, date_index, plan } = params;
    const dragData = { line_index, date_index, plan };

    e.dataTransfer.setData("text/plain", JSON.stringify(dragData));
    e.dataTransfer.effectAllowed = "move";
    setDraggedIndex(`${line_index}-${date_index}`);

    // Add visual feedback
    e.currentTarget.style.opacity = "0.5";
  },

  handleDragEnd: (e) => {
    e.currentTarget.style.opacity = "1";
    setDraggedIndex(null);
    setDropActiveIndex(null);
  },

  handleDragOver: (e, params) => {
    const { line_index, date_index, dateObj } = params;

    // Prevent drop on past dates, weekends, or fully planned days
    if (
      dateObj &&
      (dateUtils.isPastDate(dateObj.date) ||
        dateObj.week_status === "weekend" ||
        dateObj.is_full_day_planned)
    ) {
      e.dataTransfer.dropEffect = "none";
      return;
    }

    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    setDropActiveIndex(`${line_index}-${date_index}`);
  },

  handleDragLeave: (e) => {
    // Only clear if we're leaving the drop zone completely
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setDropActiveIndex(null);
    }
  },

  handleDrop: async (e, params) => {
    e.preventDefault();
    const { line_index, date_index, draggedIndex, onPlanMove, dateObj } =
      params;

    // Prevent drop on past dates or weekends
    if (dateObj && dateUtils.isPastDate(dateObj.date)) {
      message.warning("Cannot move plans to past dates");
      setDraggedIndex(null);
      setDropActiveIndex(null);
      return;
    }

    if (dateObj && dateObj.week_status === "weekend") {
      message.warning("Cannot move plans to weekends");
      setDraggedIndex(null);
      setDropActiveIndex(null);
      return;
    }

    if (dateObj && dateObj.is_full_day_planned) {
      message.warning("Cannot move plans to fully planned days");
      setDraggedIndex(null);
      setDropActiveIndex(null);
      return;
    }

    const dropTarget = `${line_index}-${date_index}`;

    if (draggedIndex === dropTarget) return;

    try {
      setDroppingIndex(dropTarget);

      const dragData = JSON.parse(e.dataTransfer.getData("text/plain"));
      await onPlanMove(dragData, { line_index, date_index });
    } catch (error) {
      console.error("Drop operation failed:", error);
    } finally {
      setDraggedIndex(null);
      setDropActiveIndex(null);
      setDroppingIndex(null);
    }
  },
});

export const createPlanMoveHandler = (calendarData, refetch) => {
  return async (dragData, dropData) => {
    const draggedPlan = dragData.plan;
    const dropLine = calendarData.calendarBody[dropData.line_index];
    const dropDateObj = dropLine.dates[dropData.date_index];
    const dropDate = dropDateObj.date;

    try {
      const response = await postData(
        "/api/productionPlanning/plan_date_change",
        {
          plan_id: draggedPlan.id || draggedPlan.plan_id,
          line_id: dropLine.line_id,
          start_date: dropDate,
        },
      );
      if (response?.code === 200) {
        message.success(response?.message || "Plan moved successfully");
        await refetch();
      } else {
        message.error(response?.message || "Failed to move plan");
      }
    } catch (error) {
      console.error("API error:", error);
      message.error("Failed to move plan");
    }
  };
};
